import { paths } from "@rms-types/constants/paths";
import { EnrollmentSidebarItem } from "@rms-types/modules/enrollment/types";
import dayjs from "dayjs";

import { SidebarItem } from "@/layouts/types";

export function generateEnrollmentSidebar(data: EnrollmentSidebarItem[]): SidebarItem[] {
  return data.map(({ company_name, created_at, id }) => ({
    label: company_name,
    secondaryLabel: dayjs(created_at).format("MMMM DD, YYYY"),
    identifier: company_name,
    link: paths.app.intakes.intakeDetails.getLink(id),
    permissions: paths.app.intakes.intakeDetails.permissions,
  }));
}
